import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DateHelper } from "../shared/helpers/date-helper";
import { PatientApi } from "./api-service/patient/patient-api";
import { RegisterEditDto } from "./api-service/register/RegisterEditDto";
import { EasyNotificationService } from "./easy-notification.service";
import { RouteInfoService } from "./route-info.service";
import { UserConfirmService } from "./user-confirm.service";
import { DentalSameTreatFollowDto, DentalTreatmentDateEndDto, GetAllQuery, RegistEditOpt, RegisterApi, RegisterQueryOptions } from "./api-service/register/register-api";
import { UserCache } from "./user-cache";
import { ClinicDataService } from "./data-service/clinic-data-service";
import { ParameterApi } from "./api-service/parameters/parameter-api";
import { TimeSectionRange } from "./api-service/register/time-section-range";
import { PageData } from "../shared/models/page-data";
import { DiscountPriorityDto, MapDiscountRule } from "./api-service/register/discount-priority-dto";
import { SexEnum } from "../enums/SexEnum";
import { ExpenseItemEnum } from "../enums/ExpenseItemEnum";
import { ValueTextPair } from "../shared/models/value-text-pair";
import { DiscountTypeEnum } from "../enums/DiscountTypeEnum";
import { HistOrder } from "../hist/models/hist-order";
import { DoctorScheduleDto, RegistDoctorInfo, ScheduleApi } from "./api-service/schedule/schedule-api";
import { FunctionEnable } from "./base-config.service";
import { OptionTypes } from "./cache-service/options-cached.service";
import { TimeSecEnum } from "../enums/TimeSecEnum";
import { RegisterConst } from "../shared/constants/register-const";
import { MemoryCache } from "./memory-cache-service";
import { AuthenticationService } from "../security/services/authentication.service";
import { Discount } from "../payments/discount/models/discount";
import { TherapistScheduleDto } from "./api-service/user/uesrSimpleInfo";
import { NullOrEmptyTrim } from "../shared/utilities";
import { MutiTreatmentListDto } from "./api-service/register/mutiTreatmentListDto";
import { SystemConst } from "../shared/constants/system-const";
import { ParamGroupEnum } from "./data-service/system-param-cache-define";
import { TherapistLastRecordDto } from "./api-service/parameters/SCH001Params";

export interface DiscountRuleData {
  RegDate?: Date;
  VisitSourceCode: string;
  ICode: string;
  SameTreat: string;
  Icno: string;
  INote: string;
  PatientBirth?: Date;
  PatientSexCode?: number;
  PatientCity: string;
  PatientArea: string;
  PatientStreet: string;
  TimeSec?: number;
  RoomCode: string;
  DoctorId?: number;
}

export interface FilterExpenseData {
  IType: string;
  SameTreat: string;
  ICode: string;
  PatientBirth?: Date;
  // HowOld?: number;
}

export class RegistInfo {
  patientId?: number;
  room?: string;
  doctorId?: number;
  dt: number;
  sec: number;
  abCode?: string;
  isCard?: boolean;
  isVHC?: boolean = false;//虛擬卡
  isFirst?: boolean;
  isOweCard?: boolean;
  isCheckin?: boolean;
  isAppointmentCheckIn?: boolean;
  isCancelRegister?: boolean;
  isHasCard?: boolean;
  hasMultipltRegister?: boolean;
  from: 'OPD' | 'REG' | 'PAT' | 'PHAR' | 'RESV' | '';
  sameTreatTP?: string;
  sameTreatRegId?: number;
  regId?: number;
  offline=false;


  constructor(patientId: number, mode: 'OPD' | 'REG' | 'PAT' | 'PHAR' | 'RESV' | '', sameTreat?: string) {
    this.sameTreatTP = sameTreat ?? '';
    this.patientId = patientId;
    this.regId = 0;
    this.from = mode;
  }
  patient(id: number) {
    this.patientId = id;
    return this;
  }
  date(date: Date): RegistInfo {
    if (date) {
      this.dt = new Date(date).getTime();
    }
    return this;
  }
  section(sec: TimeSecEnum): RegistInfo {
    this.sec = sec;
    return this;
  }
  roomTo(roomCode: string): RegistInfo {
    this.room = roomCode ?? '';
    return this;
  }
  doctor(id: number): RegistInfo {
    this.doctorId = Number(id || 0);
    return this;
  }
  dentalTreatment(regId: number): RegistInfo {
    this.sameTreatRegId = Number(regId || 0);
    return this;
  }
  reg(regId: number): RegistInfo {
    this.regId = regId;
    return this;
  }
  first(): RegistInfo {
    this.isFirst = true;
    return this;
  }
  selfPay(): RegistInfo {
    this.isCard = false;
    this.isOweCard = false;
    this.abCode = '';
    return this;
  }
  ic(): RegistInfo {
    this.isCard = true;
    this.isOweCard = false;
    this.abCode = '';
    return this;
  }

  vic(): RegistInfo {
    this.isCard = true;
    this.isOweCard = false;
    this.abCode = '';
    this.isVHC = true;
    return this;
  }
  oweCard(): RegistInfo {
    this.isCard = false;
    this.isOweCard = true;
    this.abCode = '';
    return this;
  }
  abnormal(abCode: string): RegistInfo {
    this.isCard = false;
    this.isOweCard = false;
    this.abCode = abCode;
    return this;
  }
  checkIn(options?: { isAppointment?: boolean }) {
    this.isCheckin = true;
    this.isAppointmentCheckIn = options?.isAppointment ?? false;
    return this;
  }
  cancelRegister(hasCard: boolean, hasMultipltRegister: boolean) {
    this.isCancelRegister = true;
    this.isHasCard = hasCard;
    this.hasMultipltRegister = hasMultipltRegister;
    return this;
  }
  prePack(data: Date): RegistInfo {
    if (data) {
      this.dt = new Date(data).getTime();
    }
    this.isCard = false;
    this.isOweCard = false;
    this.abCode = '';
    return this;
  }
  offlineUpload():RegistInfo{
    this.offline = true;
    return this;
  }
}
@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  //queryOptions: RegisterQueryOptions;

  get loginUserCid() { return UserCache.getLoginUser().CId; }
  get isHomeCare(): boolean { return UserCache.getLoginUser().Clinic.TypeIsHomeCare; }
  get isRecoveryHome(): boolean { return UserCache.getLoginUser().Clinic.TypeIsRecoveryHome; }
  routeRegister = '/registers/register';
  /**
   *
   */
  constructor(private patientApi: PatientApi,
    private regApi: RegisterApi,
    private schApi: ScheduleApi,
    private paramApi: ParameterApi,
    private clinicDataService: ClinicDataService,
    private notification: EasyNotificationService,
    private routeInfo: RouteInfoService,
    private router: Router,
    private userConfirm: UserConfirmService,
    private auth: AuthenticationService,
  ) {
    auth.logoutEvent.subscribe(a => {
      this.editOptions = null;
      this.userRoom = '';
      this.p289 = null;
      this.cache = new MemoryCache();
    })
  }
  private cache: MemoryCache = new MemoryCache();
  private editOptions: RegistEditOpt;
  userRoom: string = '';

  p289: string;
  // 候診清單主頁呼叫
  public async Init() {
    // 把有CACHE的先撈一撈
    if (FunctionEnable.EnableClientAdvCache) {
      var sysCodes = ['B0280', 'C0120', 'C0010', 'C0140', 'C0030', 'C0040', 'N0020', 'C0240'
        , 'E0050', 'E0060', 'E0070', 'C0020'
      ]
      if (UserCache.IsChineseMode()) {
        sysCodes.push('C0032');
      }
      await this.clinicDataService.getSystemCodes(sysCodes)
      await this.clinicDataService.getEnum(['TimeSec', 'Sex', 'SpcIdentity'])
    } else {
      await this.clinicDataService.getSystemCodes(['B0280', 'C0120', 'C0010', 'C0140', 'C0030', 'C0032', 'C0040', 'N0020', 'C0240'])
      await this.clinicDataService.getEnum(['TimeSec'])
    }

    var reg001 = await this.clinicDataService.getParam("REG001");

    var dt = DateHelper.today;
    this.p289 = await this.clinicDataService.getGPPara(289);
    const timeSecDefault = TimeSectionRange.getSectionValue(new TimeSectionRange(reg001));
    // 醫師班表快取
    this.SetRegDoctorInfo(this.clinicDataService.lastestPreloadDto.regDoctors, DateHelper.today, timeSecDefault, this.isHomeCare || this.isRecoveryHome, true);
    this.SetAgeDiscount(this.clinicDataService.lastestPreloadDto.ageDiscount, DateHelper.today)

    var sch = await this.GetSch(dt)
    this.userRoom = sch.find(x => x.UserId == UserCache.getLoginUser().UserId && x.TimeSec == timeSecDefault)?.RoomCode
      ?? [...sch].sort((x, y) => x.RoomCode > y.RoomCode ? 1 : x.RoomCode == y.RoomCode ? 0 : -1)[0]?.RoomCode
      ?? ''

    await this.clinicDataService.getOptions(OptionTypes.Doctors)
    await this.clinicDataService.GetNhiImiSetting();
    await this.clinicDataService.getParam("NIS001");
    await this.getEditOptions(null);

    this.clinicDataService.onReload.subscribe(async x => {
      this.p289 = await this.clinicDataService.getGPPara(289);
      const timeSecDefault = TimeSectionRange.getSectionValue(new TimeSectionRange(reg001));
      // 醫師班表快取
      this.SetRegDoctorInfo(this.clinicDataService.lastestPreloadDto.regDoctors, DateHelper.today, timeSecDefault, this.isHomeCare || this.isRecoveryHome, true);
      this.SetAgeDiscount(this.clinicDataService.lastestPreloadDto.ageDiscount, DateHelper.today)
    })
  }

  public async GetSch(date: Date): Promise<DoctorScheduleDto[]> {
    return await this.clinicDataService.GetDoctorSchdule(date);
  }
  public async HasSch(dt: Date, sec: TimeSecEnum) {
    var sch = await this.GetSch(dt);
    // 全部時段
    return sec == TimeSecEnum.None ? sch.length > 0 : sch.some(x => x.TimeSec == sec);
  }
  public async GetQueryOptions(): Promise<RegisterQueryOptions> {
    // 這些都有快取
    // 後面的是順便幫別的元件先載入
    var sysCodes = ['B0280', 'C0120', 'C0010', 'C0140', 'C0030', 'C0040', 'N0020', 'C0240'];
    if (UserCache.IsChineseMode()) {
      sysCodes.push('C0032');
    }
    var codes = await this.clinicDataService.getSystemCodes(sysCodes)
    var enums = await this.clinicDataService.getEnum(['TimeSec'])
    var reg001 = await this.clinicDataService.getParam("REG001");

    return {
      //clinicId:UserCache.getLoginClinicId().toString(),
      room: this.userRoom,
      timeSection: enums['TimeSec'],
      remark: codes['B0280'] ?? [],  // 用戶可以不設預設值=>會取不到清單資料(undefined)，所以要加判斷
      medRoom: codes['C0120'],
      insurance: codes['C0010'],
      visitType: codes['C0140'],
      registerType: UserCache.IsChineseMode() ? codes['C0032'] : codes['C0030'].map(x => {
        if (x.value == '') {
          x.text = '一般看診'
        }
        return x;
      }),
      // registerType: codes['C0030'],
      status: codes['C0040'],
      paramList: reg001,
      timeSectionRange: new TimeSectionRange(reg001)
    }
  }
  public async GetRegDoctorInfo(date: Date, timeSec: TimeSecEnum, isHomeCareOrRecovery: boolean, iseditDoc: boolean): Promise<RegistDoctorInfo> {
    var key = `D_${(date?.toLocaleDateString() ?? "EMPTY")}_${timeSec}_${isHomeCareOrRecovery ? 1 : 0}_${iseditDoc ? 1 : 0}}`;
    if (this.cache.has(key)) {
      return this.cache.get(key);
    } else {
      var ret = await this.schApi.GetDoctors(date, timeSec, isHomeCareOrRecovery, iseditDoc)
      this.cache.set(key, ret);
      return ret;
    }
  }
  public async SetRegDoctorInfo(registDoctorInfo: RegistDoctorInfo, date: Date, timeSec: TimeSecEnum, isHomeCareOrRecovery: boolean, iseditDoc: boolean) {
    var key = `D_${(date?.toLocaleDateString() ?? "EMPTY")}_${timeSec}_${isHomeCareOrRecovery ? 1 : 0}_${iseditDoc ? 1 : 0}}`;
    if (!this.cache.has(key)) {
      return this.cache.set(key, registDoctorInfo);
    }
  }
  public async GetAgeDiscount(regDateTime: Date): Promise<Discount[]> {
    var key = `AGEDISCOUNT_${(regDateTime.toISOString())}`;
    if (this.cache.has(key)) {
      return this.cache.get(key);
    } else {
      var ret = await this.regApi.GetAgeDiscount(regDateTime);;
      this.cache.set(key, ret);
      return ret;
    }
  }
  public SetAgeDiscount(discount: Discount[], regDateTime: Date) {
    var key = `AGEDISCOUNT_${(regDateTime.toISOString())}`;
    if (!this.cache.has(key)) {
      this.cache.set(key, discount);
    }
  }
  public async GetRehabitMedUesrs(regDateTime: Date): Promise<TherapistScheduleDto[]> {
    if (FunctionEnable.EnableClientAdvCache) {
      return await this.clinicDataService.GetRehabitMedUesr(regDateTime);
    } else {
      return await this.regApi.GetRehabitMedUesrs(regDateTime);
    }
  }
  //editOptionCache:Map<string,RegistEditOpt2> = new Map()
  public async getEditOptions(regDate: Date) {
    // 呼叫api
    try {
      this.editOptions = new RegistEditOpt();
      var sysCodes = ['C0010', 'C0040', 'C0120', 'C0140', 'C0020', 'C0030', 'C0240']
      if (UserCache.IsChineseMode()) {
        sysCodes.push('C0032');
      }
      var codes = await this.clinicDataService.getSystemCodes(sysCodes);
      var enums = await this.clinicDataService.getEnum(['TimeSec', 'Sex', 'SpcIdentity']);
      var reg001 = await this.clinicDataService.getParam('REG001');
      var pay001 = await this.clinicDataService.getParam('PAY001');
      //system-code
      this.editOptions.insurance = [...codes['C0010']];
      this.editOptions.statusCode = [{ value: '', text: '' }, ...codes['C0040']];
      this.editOptions.medRoom = [{ value: '', text: '' }, ...codes['C0120']];
      this.editOptions.visitType = [{ value: '', text: '' }, ...codes['C0140']];
      this.editOptions.section = [{ value: '', text: '' }, ...codes['C0020']];
      this.editOptions.registerType = UserCache.IsChineseMode() ? [...codes['C0032']] : [{ value: '', text: '一般門診' }, ...codes['C0030']];
      // 掛號櫃台修改掛號時，只能選擇部分狀態
      this.editOptions.fullStatusCode = this.editOptions.statusCode;
      this.editOptions.statusCode = this.editOptions.statusCode.filter(x => RegisterConst.StatusCodeList_CanSelect.indexOf(x.value) > -1);
      //C0240 身分備註  先排除這兩個來路不明的 確定不用再刪除
      this.editOptions.inote = [{ value: '', text: '' }, ...codes['C0240'].filter(x => !['+OP', '+AU'].includes(x.value))];
      //從參數來的
      this.editOptions.regParam = reg001;
      var today = DateHelper.today;
      today.setDate(today.getDate() + reg001.MaxAppointmentDays);
      this.editOptions.MaxAppointmentDate = today;
      this.editOptions.IsPrintReceipt = reg001.IsPrintReceipt;
      this.editOptions.timeSectionRange = new TimeSectionRange(reg001);
      this.editOptions.OverTimeCheck = reg001.OverTimeCheck;
      this.editOptions.payWay = pay001.DisplayFeeCodes,
        this.editOptions.isBeforeCharge = pay001.ChargeFlow == 'multi' || pay001.ChargeFlow == 'before'
      //enum
      if (!reg001.HasNight) {
        this.editOptions.timeSection = enums['TimeSec'].filter(x => x.value != TimeSecEnum.Night);
      } else {
        this.editOptions.timeSection = enums['TimeSec']
      }
      this.editOptions.sex = enums['Sex'];
      this.editOptions.spcIdentity = enums['SpcIdentity'];
      try{
        var discountPriority = await this.clinicDataService.GetDiscountPriority(regDate);
        this.editOptions.discountPriority = discountPriority.filter(x =>
          [ExpenseItemEnum.All, ExpenseItemEnum.Deposit, ExpenseItemEnum.OwnFee,
          ExpenseItemEnum.RegisterFee, ExpenseItemEnum.SelfPay].includes(x.ExpenseItem));
      }catch{
        this.editOptions.discountPriority = []
      }
      try{
        this.editOptions.discount = await this.clinicDataService.GetDiscount(regDate);
      }catch{
        this.editOptions.discount = [];
      }
      try{
        this.editOptions.naturalDisasterRxDto = await this.clinicDataService.GetNaturalDisasterRx(regDate);
      }catch{
        this.editOptions.naturalDisasterRxDto = [];
      }
    } catch (ex) {
      this.notification.showError(ex);
    }
    return this.editOptions;
  }

  async Regist(patientId: number) {
    try {
      var data: RegisterEditDto[] = await this.patientApi.GetRegister(DateHelper.today, patientId);
      if (data == null || data.length === 0) {
        // 前往掛號頁面
        this.gotoRegPageForAdd(patientId);
      } else {
        // 若已有掛號紀錄，開啟詢問視窗(是否繼續掛號)
        var ret = await this.userConfirm.showConfirm({
          msg: '此病患今日已有掛號, 你要再次掛號嗎?',
          title: '掛號確認'
        });
        if (ret) {
          this.gotoRegPageForAdd(patientId);
        }
      }
      return true;
    } catch (ex) {
      this.notification.showGetDataFailed();
      return false;
    }
  }

  // 前往掛號頁面
  gotoRegPageForAdd(patientId: number) {
    // 路徑
    const path = this.routeInfo.makeFullUrl(this.routeRegister);
    this.router.navigate([path, { patientId: patientId }]);
  }

  async query(query: GetAllQuery): Promise<PageData> {
    return await this.regApi.GetAll(query);
  }

  goToRegPage(info: RegistInfo) {
    const path = this.routeInfo.makeFullUrl(this.routeRegister);
    // 先等UI更新做完
    setTimeout(() => {
      //轉跳至掛號畫面
      this.router.navigate([path, info]);
      //console.log("goToRegPage", path);
    }, 100);
  }

  isReasonableDate(sourceDate: Date, targetDate: Date): boolean {
    const source = new Date(sourceDate);
    const target = new Date(targetDate);
    source.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    return source >= target;
  }

  calculateAge(src: any, thatday?: Date): [string, number] {
    if (src == null || src == '') {
      return ['', null];
    }

    var result = "";
    // collect input date
    var dob = new Date(src);
    var dobYear = dob.getFullYear();
    var dobMonth = dob.getMonth();
    var dobDate = dob.getDate();

    // get the current date from the system
    var now = new Date();
    if (thatday) now = new Date(thatday);
    // extract the year, month, and date from current date
    var currentYear = now.getFullYear();
    var currentMonth = now.getMonth();
    var currentDate = now.getDate();

    // get years
    var yearAge = currentYear - dobYear;

    // get months
    if (currentMonth >= dobMonth) {
      //get months when current month is greater
      var monthAge = currentMonth - dobMonth;
    } else {
      yearAge--;
      var monthAge = 12 + currentMonth - dobMonth;
    }

    // get days
    if (currentDate >= dobDate) {
      // get days when the current date is greater
      var dateAge = currentDate - dobDate;
    } else {
      monthAge--;
      // get the days in the last month
      var daysInLastMonth = new Date(currentYear, currentMonth, 0).getDate();
      var dateAge = daysInLastMonth + currentDate - dobDate;
      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }
    var howOld = yearAge;
    // group the age in a single variable
    result = yearAge + '歲' + monthAge + '月' + dateAge + '天';
    return [result, howOld];
  }

  /** 優免條件json如下, 符合條件的優免項目再依優先順序排序
   * 全部適用 All Y/N
   * 自行選擇(優待下拉選項中) MakeChoice Y/N
   * 一般/急診 RegisterMode: General/Emergency
   * 初複診 OutpatientType: First/FollowUp
   * 身分(可多選) ICode
   * 類別(可多選) SameTreat
   * 卡序(可多選) Icno
   * 備註(可多選) INote
   * 年齡 AgeStart, AgeStartExpression(>,<,=,>=,<=,!=), AgeEnd, AgeEndExpression
   * 性別 Sex
   * 診所地區 Area
   * 病患地區 PatientArea
   * 時段 TimeSec
   * 診間 RoomCode
   * 醫師 DoctorId
   */
  parseDiscountRule(dto: DiscountPriorityDto[], data: DiscountRuleData, basicDiscountCode: string): DiscountPriorityDto[] {
    var discounts: DiscountPriorityDto[] = [];
    let basic = basicDiscountCode;
    let regDate = data.RegDate;
    let dataVisitSourceCode = data.VisitSourceCode;
    let dataICode = data.ICode;
    let dataSameTreat = data.SameTreat;
    let dataIcno = data.Icno;
    let dataINote = data.INote;
    let dataPatientBirth = data.PatientBirth;
    let dataPatientSexCode = data.PatientSexCode;
    let dataPatientCity = data.PatientCity;
    let dataPatientArea = data.PatientArea;
    let dataPatientStreet = data.PatientStreet;
    let dataTimeSec = data.TimeSec;
    let dataRoomCode = data.RoomCode;
    let dataDoctorId = data.DoctorId;

    dto.forEach(x => {
      //起迄日期判斷於API也有做
      if (regDate && x.StartDate && !this.isReasonableDate(regDate, x.StartDate)) {
        return;
      }
      if (regDate && x.EndDate && !this.isReasonableDate(x.EndDate, regDate)) {
        return;
      }

      //如果是基本資料的優免，直接帶入，不判斷rule，後續去做排序比較
      //基本資料的優免整合欄位改成文字才能存多筆
      if (basic.includes(',')) {
        let basics = basic.split(',').filter(z => z) ?? [];
        if (basics.length !== 0) {
          if (basics.some(z => z === x.Code)) {
            discounts.push(x);
            return;
          }
        }
      } else {
        if (x.Code === basic) {
          discounts.push(x);
          return;
        }
      }

      if (!x.DiscountRule) {
        return;
      }

      var jsonObj: MapDiscountRule;
      try {
        jsonObj = JSON.parse(x.DiscountRule) as MapDiscountRule;
      } catch (e) {
        jsonObj = null;
      }
      if (!jsonObj) {
        return;
      }

      //全部都沒設定,或設定不對,就不執行此優待
      if (!jsonObj.RegisterMode
        && !jsonObj.OutpatientType
        && !jsonObj.ICode
        && !jsonObj.SameTreat
        && !jsonObj.Icno
        && !jsonObj.INote
        && !jsonObj.AgeStart
        && !jsonObj.AgeStartExpression
        && !jsonObj.AgeEnd
        && !jsonObj.AgeEndExpression
        && !jsonObj.Sex
        && !jsonObj.Area
        && !jsonObj.PatientArea
        && !jsonObj.TimeSec
        && !jsonObj.RoomCode
        && !jsonObj.DoctorId
        && !jsonObj.All
        && !jsonObj.MakeChoice
        && !jsonObj.Weekdays) {
        return;
      }

      //全部適用 All Y/N
      if (jsonObj.All !== undefined) {
        let all = jsonObj.All ?? '';
        if (all === 'Y') {
          discounts.push(x);
          return;
        }
      }

      //自行選擇(優待下拉選項中) MakeChoice Y/N
      if (jsonObj.MakeChoice !== undefined) {
        let makeChoice = jsonObj.MakeChoice ?? '';
        if (makeChoice === 'Y') {
          // x.MakeChoice = true;
          // x.Priority = 100;//自行選擇的優先度一律改最低100, 一般設定優先順序是1~99
          // discounts.push(x);
          let newDto = Object.assign(new DiscountPriorityDto(), x);
          newDto.MakeChoice = true;
          newDto.Priority = 100;//自行選擇的優先度一律改最低100, 一般設定優先順序是1~99
          discounts.push(newDto);
          return;
        }
      }

      //一般/急診 RegisterMode: General/Emergency
      if (jsonObj.RegisterMode !== undefined) {
        let registerMode = jsonObj.RegisterMode ?? '';
        // 目前沒得判斷，先不做
      }

      //初複診 OutpatientType: First/FollowUp
      if (jsonObj.OutpatientType !== undefined) {
        let outpatientType = jsonObj.OutpatientType ?? '';
        if (outpatientType !== 'First' && outpatientType !== 'FollowUp') {
          return;
        }
        if (outpatientType === 'First' && dataVisitSourceCode !== 'F') {
          return;
        }
        if (outpatientType === 'FollowUp' && dataVisitSourceCode !== 'R') {
          return;
        }
      }

      //身分(可多選) ICode
      if (jsonObj.ICode !== undefined) {
        let icodes = jsonObj.ICode?.split(',').filter(x => x) ?? [];
        if (icodes.length === 0) {
          return;
        }
        if (!icodes.some(x => x === dataICode)) {
          return;
        }
      }

      //類別(可多選) SameTreat
      if (jsonObj.SameTreat !== undefined) {
        let sameTreats = jsonObj.SameTreat?.split(',').filter(x => x) ?? [];
        if (sameTreats.length === 0) {
          return;
        }
        if (!sameTreats.some(x => x === dataSameTreat)) {
          return;
        }
      }

      //卡序(可多選) Icno
      if (jsonObj.Icno !== undefined) {
        let icnos = jsonObj.Icno?.split(',').filter(x => x) ?? [];
        if (icnos.length === 0) {
          return;
        }
        if (!icnos.some(x => x === dataIcno)) {
          return;
        }
      }

      //備註(可多選) INote
      if (jsonObj.INote !== undefined) {
        let inotes = jsonObj.INote?.split(',').filter(x => x) ?? [];
        if (inotes.length === 0) {
          return;
        }
        if (!inotes.some(x => x === dataINote)) {
          return;
        }
      }

      //年齡
      // AgeStart, AgeStartExpression(>,<,=,>=,<=,!=)
      // AgeEnd, AgeEndExpression
      const acceptExpression = SystemConst.AcceptExpression;
      if ((jsonObj.AgeStart !== undefined && jsonObj.AgeStartExpression !== undefined) ||
        (jsonObj.AgeEnd !== undefined && jsonObj.AgeEndExpression !== undefined)) {
        let ageStart = jsonObj.AgeStart ? Number(jsonObj.AgeStart) : null;
        let ageStartExpression = jsonObj.AgeStartExpression ?? '';
        let ageEnd = jsonObj.AgeEnd ? Number(jsonObj.AgeEnd) : null;
        let ageEndExpression = jsonObj.AgeEndExpression ?? '';
        if (jsonObj.AgeStart !== undefined && jsonObj.AgeStartExpression !== undefined) {
          if (ageStart === null || !acceptExpression.includes(ageStartExpression)) {
            return;
          }
        }
        if (jsonObj.AgeEnd !== undefined && jsonObj.AgeEndExpression !== undefined) {
          if (ageEnd === null || !acceptExpression.includes(ageEndExpression)) {
            return;
          }
        }

        let years = '';
        let howOld = 0;
        [years, howOld] = this.calculateAge(DateHelper.formatDateTime(dataPatientBirth));
        let yearsOld = howOld;

        if (ageStart !== null && yearsOld !== null) {
          switch (ageStartExpression) {
            case '>':
              if (!(yearsOld > ageStart)) return;
              break;
            case '<':
              if (!(yearsOld < ageStart)) return;
              break;
            case '=':
              if (!(yearsOld === ageStart)) return;
              break;
            case '>=':
              if (!(yearsOld >= ageStart)) return;
              break;
            case '<=':
              if (!(yearsOld <= ageStart)) return;
              break;
            case '!=':
              if (!(yearsOld !== ageStart)) return;
              break;
            default:
              return;
          }
        }
        if (ageEnd !== null && yearsOld !== null) {
          switch (ageEndExpression) {
            case '>':
              if (!(yearsOld > ageEnd)) return;
              break;
            case '<':
              if (!(yearsOld < ageEnd)) return;
              break;
            case '=':
              if (!(yearsOld === ageEnd)) return;
              break;
            case '>=':
              if (!(yearsOld >= ageEnd)) return;
              break;
            case '<=':
              if (!(yearsOld <= ageEnd)) return;
              break;
            case '!=':
              if (!(yearsOld !== ageEnd)) return;
              break;
            default:
              return;
          }
        }
      }

      //性別 Sex
      if (jsonObj.Sex !== undefined) {
        let sex = (jsonObj.Sex === '0' || jsonObj.Sex === '1') ? (Number(jsonObj.Sex) as SexEnum) : SexEnum.SexNone;
        if (sex !== SexEnum.SexMan && sex !== SexEnum.SexWoman) {
          return;
        }
        if (sex === SexEnum.SexMan && dataPatientSexCode !== SexEnum.SexMan) {
          return;
        }
        if (sex === SexEnum.SexWoman && dataPatientSexCode !== SexEnum.SexWoman) {
          return;
        }
      }

      //診所地區 Area
      if (jsonObj.Area !== undefined) {
        let area = jsonObj.Area ?? '';
        if (!area) {
          return;
        }
        var cln = UserCache.getLoginUser().Clinic;
        var clinicAddr = (cln.City ?? '') + (cln.Area ?? '') + (cln.Street ?? '');
        if (!clinicAddr.includes(area)) {
          return;
        }
      }

      //病患地區 PatientArea
      if (jsonObj.PatientArea !== undefined) {
        let patientArea = jsonObj.PatientArea ?? '';
        if (!patientArea) {
          return;
        }
        var patientAddr = (dataPatientCity ?? '') + (dataPatientArea ?? '') + (dataPatientStreet ?? '');
        if (!patientAddr.includes(patientArea)) {
          return;
        }
      }

      //時段 TimeSec
      if (jsonObj.TimeSec !== undefined) {
        let timeSec = jsonObj.TimeSec ? Number(jsonObj.TimeSec) : null;
        if (timeSec === null) {
          return;
        }
        if (timeSec !== dataTimeSec) {
          return;
        }
      }

      //診間 RoomCode
      if (jsonObj.RoomCode !== undefined) {
        let roomCode = jsonObj.RoomCode ?? '';
        if (!roomCode) {
          return;
        }
        if (roomCode !== dataRoomCode) {
          return;
        }
      }

      //醫師 DoctorId
      if (jsonObj.DoctorId !== undefined) {
        let doctorId = jsonObj.DoctorId ? Number(jsonObj.DoctorId) : null;
        if (doctorId === null) {
          return;
        }
        if (doctorId !== dataDoctorId) {
          return;
        }
      }

      //星期幾套用判斷
      if (jsonObj.Weekdays !== undefined) {
        var weekdays = jsonObj.Weekdays.split(',');

        var day = String(regDate.getDay());

        if (!weekdays.includes(day)) {
          return;
        }
      }

      discounts.push(x);
    });

    // 排序依優先順序由小到大,越小越優先,ID由大到小
    var discountRules = discounts.sort((a, b) => {
      if (a.Priority === b.Priority) {
        return b.Id - a.Id;
      }
      return a.Priority - b.Priority;
    });

    return discountRules;
  }

  filterExpenseItem(expenseItem: ExpenseItemEnum, discountRules: DiscountPriorityDto[], data: FilterExpenseData): [ValueTextPair[], string] {
    let iType = data.IType;
    let sameTreat = data.SameTreat;
    let iCode = data.ICode;
    let patientBirth = data.PatientBirth;
    let years = '';
    let howOld = 0;
    [years, howOld] = this.calculateAge(DateHelper.formatDateTime(patientBirth));
    howOld = howOld ?? 0;

    let items: ValueTextPair[] = [];

    let filter = discountRules.filter(x =>
      x.ExpenseItem === expenseItem ||
      (expenseItem === ExpenseItemEnum.RegisterFee && x.ExpenseItem === ExpenseItemEnum.All)
    );

    items = filter.map(x => ({
      text: this.showDiscountName(filter.length, x), value: x.Code, extension: x.MakeChoice,
      ext2: x.ExpenseItem,  //增加ExpenseItem,判斷用
      ext3: x.Id  //增加Id,判斷用
    }));
    //比照後端GetRegistPayInfo()判斷
    //如果不是欠卡就沒押金
    if (expenseItem === ExpenseItemEnum.Deposit && iType !== '3') {
      items = [];
    }
    //慢箋領藥沒部分負擔
    if (expenseItem === ExpenseItemEnum.OwnFee && '2,3,8'.split(',').some(x => x === sameTreat)) {
      items = [];
    }
    //年齡小於3歲或大於100歲沒部分負擔
    if (expenseItem === ExpenseItemEnum.OwnFee && (howOld <= 3 || howOld >= 100)) {
      items = [];
    }
    //不是身分A沒部分負擔
    if (expenseItem === ExpenseItemEnum.OwnFee && iCode !== 'A') {
      items = [];
    }
    let itemText = '無'
    //不是身分A沒部分負擔
    if (expenseItem === ExpenseItemEnum.SelfPay) {
      itemText += '| (依輸入金額)'
    }
    items.push({ text: itemText, value: '' });
    let bestItemValue = items.filter(x => !x.extension).map(x => x.value)[0];
    return [items, bestItemValue];
  }
  check復健免費ByHrx(input: HistOrder[]): boolean {
    var orders = input.filter(x => x.StdCode && x.RxType == 8 && (x.StdCode.startsWith("420") || x.StdCode.startsWith("430") || x.StdCode.startsWith("440")))
    if (orders.some(x => x.StdCode && x.RxType == 8 && x.StdCode.startsWith("4200"))) return false;
    else if (orders.some(x => x.StdCode == '42017C' && x.RxType == 8)) return false;
    else if (orders.some(x => x.StdCode && x.RxType == 8 && x.StdCode.startsWith("4201"))) return true;
    else if (orders.some(x => x.StdCode && x.RxType == 8 && (x.StdCode.startsWith("430") || x.StdCode.startsWith("440")))) return true;
    return false;
  }
  check針傷免費ByHrx(input: HistOrder[]): boolean {
    //中醫針傷接續療程免部分負擔
    // 針傷部份負擔 3L.A98
    // 針1:50  傷1:50   針傷1:50
    // 針2-6:0 傷2-6:50 針傷2-6:0 (針傷是擇優)
    var free =
      //針灸
      input.some(x => x.StdCode && x.StdCode?.startsWith("D") && x.StdCode?.length === 3 && x.RxType === 7) ||
      //傷科
      // input.some(x => x.StdCode && x.StdCode?.startsWith("E") && x.StdCode?.length === 3 && x.RxType === 8) ||
      //針傷
      input.some(x => x.StdCode && x.StdCode?.startsWith("F") && x.StdCode?.length === 3 && x.RxType === 7) ||
      //一般針灸/一般傷科不會打DEF開頭醫令會打穴位等
      // input.some(x => x.RxCode && (x.RxType === 7 || x.RxType === 8));
      input.some(x => x.RxCode && x.RxType === 7);
    return free;
  }
  /**特治醫令對照 如果相關規則可以寫在這 */
  check復健醫令對照特治ByHrx(
    input: HistOrder[],
    SPTXStr: string[] = []
  ) {
    const hasTM = input.some(
      x => x.RxCode === 'TMR01' || x.RxCode === 'TMP01'
    );

    const gcIndex = SPTXStr.findIndex(x => x === 'GC');
    const hasGc = gcIndex !== -1;

    // 1️⃣ 有 TM 且有 GC → 不動
    if (hasTM && hasGc) {
      return;
    }
    else if (!hasTM && hasGc) {
      SPTXStr[gcIndex] = '';
      return;
    }
    // 3️⃣ 有 TM 但沒有 GC → 固定補在首位
    else if (hasTM && !hasGc) {
      const newArr = ['GC'];

      // 把原本的值（非空）依序塞進來，最多 3 個
      for (const v of SPTXStr) {
        if (!NullOrEmptyTrim(v) && newArr.length < 4) {
          newArr.push(v);
        }
      }
      // 補滿長度 4
      while (newArr.length < 4) {
        newArr.push('');
      }
      for (let i = 0; i < 4; i++) {
        SPTXStr[i] = newArr[i];
      }

      return;
    }

    // 4️⃣ 其他情況 → 不動
  }
  /**簡易的過濾 */
  get復健DisableClick(input: HistOrder): boolean {
    if (!input) return false;
    var stdCode = input.StdCode;
    if (stdCode == '42016C' || stdCode == '44010C ') return true;
    const match = stdCode.match(/^430(\d{2})C$/);
    if (!match) return false;
    const number = parseInt(match[1], 10);
    const excluded = [27, 28, 29];
    if (number >= 10 && number <= 38 && !excluded.includes(number)) return true;
    return false;
  }
  public async get復健當日最後復健師(): Promise<TherapistLastRecordDto> {
    var sch001 = await this.clinicDataService.getParam("SCH001");
    return TherapistLastRecordDto.fromString(sch001.TherapistLastRecord)
  }
  public async update復健當日最後復健師(dto: TherapistLastRecordDto): Promise<TherapistLastRecordDto> {
    var sch001 = await this.clinicDataService.getParam("SCH001");
    var str = dto.toString();
    if (sch001?.TherapistScheduledRunning != 2) return;
    try {
      await this.paramApi.UpdateParamGroup(ParamGroupEnum.SCH001, { 'TherapistLastRecord': str } as any);
      this.notification.showSuccess('更新成功');
      return dto;
    } catch (e) {
      this.notification.showError(e);
    }
  }
  public async Get復健師排班提示訊息(regDateTime: Date) {
    var sch001 = await this.clinicDataService.getParam("SCH001");
    if (!sch001.TherapistScheduledNotify) return;
    var users = await this.GetRehabitMedUesrs(regDateTime);
    if (users?.length < 1) {
      var ret = await this.userConfirm.showConfirm({
        msg: '今日復健排班表缺少排班人員!',
        title: '排班確認'
      });
    }
  }
  showDiscountName(itemCount: number, item: DiscountPriorityDto): string {
    var name = ((itemCount > 1 && !item.MakeChoice) ? '(' + item.Priority + ')' + item.Name : item.Name);
    var splitChar = '';
    switch (item.DiscountType) {
      case DiscountTypeEnum.NoDiscount:
        name += splitChar + '(無)';
        break;
      case DiscountTypeEnum.DiscountPercent:
        //0%=全折, 100%=不折, 80%=8折
        name += splitChar + (item.DiscountValue === 0 ? '全折' : item.DiscountValue === 100 ? '不折' : item.DiscountValue / 10 + '折');
        break;
      case DiscountTypeEnum.DiscountAmount:
        name += splitChar + '-' + item.DiscountValue;
        break;
      case DiscountTypeEnum.AdditionPercent:
        name += splitChar + '+' + item.DiscountValue + '%';
        break;
      case DiscountTypeEnum.AdditionAmount:
        name += splitChar + '+' + item.DiscountValue;
        break;
      case DiscountTypeEnum.FixedAmount:
        name += splitChar + '=' + item.DiscountValue;
        break;
      default:
        break;
    }
    return name;
  }
  async GetEveryTreatmentList(patientid: number, regdate: string, sameTreat: string, birthDayStr: string = '', regId: number = 0, includeEnded: boolean = false): Promise<MutiTreatmentListDto[]> {
    console.log('regId', regId)
    var paramREG001 = await this.clinicDataService.getParam("REG001");
    var extDaysTreats = paramREG001.ExtensiveDaysForTreatment ? JSON.parse(paramREG001.ExtensiveDaysForTreatment) : { ExtenSiveDays: 0, ConfigDate: null };
    var birthDay = !NullOrEmptyTrim(birthDayStr) ? birthDayStr : null;
    return await this.regApi.GetEveryTreatmentList(patientid, regdate, sameTreat, birthDayStr, extDaysTreats.ExtenSiveDays, '', regId, includeEnded);
  }
  async GetEveryDentalTreatmentList(patientid: number, regdate: string, sameTreat: string, birthDayStr: string = '', includeEnded: boolean = false): Promise<MutiTreatmentListDto[]> {
    var paramREG001 = await this.clinicDataService.getParam("REG001");
    var extDaysTreats = paramREG001.ExtensiveDaysForTreatment ? JSON.parse(paramREG001.ExtensiveDaysForTreatment) : { ExtenSiveDays: 0, ConfigDate: null };
    var birthDay = !NullOrEmptyTrim(birthDayStr) ? birthDayStr : null;
    return await this.regApi.GetEveryTreatmentList(patientid, regdate, sameTreat, birthDayStr, extDaysTreats.ExtenSiveDays, '牙', 0, includeEnded);
  }

  async GetEveryDentalTreatmentListByRegId(patientid: number, regdate: string, sameTreat: string, regId: number, birthDayStr: string = '', includeEnded: boolean = false): Promise<MutiTreatmentListDto[]> {
    var paramREG001 = await this.clinicDataService.getParam("REG001");
    var extDaysTreats = paramREG001.ExtensiveDaysForTreatment ? JSON.parse(paramREG001.ExtensiveDaysForTreatment) : { ExtenSiveDays: 0, ConfigDate: null };
    var birthDay = !NullOrEmptyTrim(birthDayStr) ? birthDayStr : null;
    return await this.regApi.GetEveryTreatmentList(patientid, regdate, sameTreat, birthDayStr, extDaysTreats.ExtenSiveDays, '牙', regId, includeEnded);
  }

  private isApiNotFoundError(error: any): boolean {
    return error?.status === 404 || error?.Status === 404;
  }

  async SetDentalTreatmentDateEnd(patientid: number, item: MutiTreatmentListDto, dateEnd: string | Date | null): Promise<boolean> {
    const regIds = (item?.HistList || [])
      .map((x: any) => x?.Register?.Id)
      .filter((x: number) => !!x);
    const data: DentalTreatmentDateEndDto = {
      patientId: patientid,
      sameTreat: item?.CusTP,
      regIds,
      dateEnd
    };
    try {
      var ret = await this.regApi.SetDentalTreatmentDateEnd(data);
      return ret?.IsSuccess === true && Number(ret.Object || 0) > 0;
    } catch (error) {
      if (this.isApiNotFoundError(error)) {
        throw '後端尚未提供「設定牙科同療程結束日」API，請更新或重啟 HIS WebApi 後再試。';
      }
      throw error;
    }
  }

  async ConvertHistoryToDentalSameTreat(patientid: number, regId: number): Promise<boolean> {
    const data: DentalSameTreatFollowDto = {
      patientId: patientid,
      regId,
      sameTreat: '5'
    };
    try {
      var ret = await this.regApi.ConvertHistoryToDentalSameTreat(data);
      return ret?.IsSuccess === true && Number(ret.Object || 0) > 0;
    } catch (error) {
      if (this.isApiNotFoundError(error)) {
        throw '歷史病歷轉為牙科同療失敗：目前 HIS WebApi 尚未提供 ConvertHistoryToDentalSameTreat API';
      }
      throw error;
    }
  }

  readonly codeTextMap: { [code: string]: string } = {
    [RegisterConst.Code_Status_Examining]: '就診中',
    [RegisterConst.Code_Status_Waiting]: '候診',
    [RegisterConst.Code_Status_Queue1]: '排1',
    [RegisterConst.Code_Status_RegNotPay]: '已掛號未付款',
    [RegisterConst.Code_Status_ReservedLater]: '保留排後',
    [RegisterConst.Code_Status_Appointment]: '預約',
    [RegisterConst.Code_Status_AppointmentCheckIn]: '預約報到',
    [RegisterConst.Code_Status_Finish]: '完診',
    [RegisterConst.Code_Status_PickUpDrug]: '拿藥',
    [RegisterConst.Code_Status_Cancel]: '取消',
    [RegisterConst.Code_Status_Emergency]: '急診',
    [RegisterConst.Code_Status_Duplication]: '複製',
    [RegisterConst.Code_Status_ReservedFront]: '保留排前'
  };

  getCodeText(code: string): string {
    return this.codeTextMap[code] || code;
  }

}
